import { render } from "./KullanimKosullari.vue?vue&type=template&id=160f17a4&scoped=true"
import script from "./KullanimKosullari.vue?vue&type=script&lang=js"
export * from "./KullanimKosullari.vue?vue&type=script&lang=js"

import "./KullanimKosullari.vue?vue&type=style&index=0&id=160f17a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160f17a4"]])

export default __exports__